/**
 * Used to describe dimensions of all frontBars
 * @param height Height in m
 * @param width Width in m
 * @param depth Depth in m
 * @param color Color of the bar
 * @param angle Describes the rotation angle of the outer top bars
 */

export const roofTopBar = {
  height: 0.023,
}

export const frontBar = {
  height: 0.08,
  width: 0.08,
  depth: 0.08,
  color: '#C0C0C0',
  angle: 0.08,
}

export const attachedBar = {
  height: 0.113,
  depth: 0.08,
  color: '#C0C0C0',
}

export const detachedBar = {
  height: 0.19,
  depth: 0.12,
  color: '#C0C0C0',
}

export const brush = {
  width: 0.02,
  depth: 0.005,
  color: 'grey'
}

// SolarPanel

export const panelDimensions = 0.159

export const solarCellThickness = 0.001

export const borderWidth = 0.03

export const cellSpacinV = 0.03

export const cellSpacinH = 0.03

